module.exports = __webpack_public_path__ + "img/logo4.b68ebef8.png";